export default __webpack_public_path__ + "static/media/network.9dd013b7.svg";